import clsx from 'clsx';
import { ButtonHTMLAttributes } from 'react';
import { Subtitle } from '../subtitle';

type TextButtonProps = Omit<
  ButtonHTMLAttributes<HTMLSpanElement>,
  'className'
> & { secondary?: boolean };

export const TextButton: React.FC<TextButtonProps> = ({
  children,
  secondary,
  ...props
}) => (
  <button
    className={clsx(
      'text-body hover:text-opacity-100 focus:text-dark disabled:text-gray-soft',
      secondary
        ? 'text-opacity-50 hover:text-opacity-100 focus:text-dark focus:text-opacity-100'
        : 'underline hover:text-dark focus:text-blue-dark'
    )}
    {...props}
  >
    <Subtitle>{children}</Subtitle>
  </button>
);
